export const projects = [
  {
    title: "IV Infusion Monitor",
    description: "A low-cost infusion monitoring system designed for hospitals in resource-limited settings.",
    techStack: ["STM32 Hal", "TouchGFX", "C", "ST-LINK-V3"],
    github: "https://github.com/teamflowmichigan/device-source-code",
    hasGithub: true,
    detailsPage: "/projects/medical-device",
  },
  {
    title: "Trancription Factor Binding Sites Model",
    description: "Bayesian modeling for predicting transcription factor binding site rates using motif and ChIP-seq data.",
    techStack: ["Python", "Stan", "Jupyter"],
    github: "https://github.com/sophieyzhou/ctcf-tf-binding",
    hasGithub: true,
    detailsPage: "/projects/genetics-ml",
  },
  {
    title: "Hydrogen Grid Optimizer",
    description: "Optimizer that makes cost minimizing energy generation decisions on a hydrogen storage integrated grid.",
    techStack: ["Python", "Conda", "pyomo", "matplotlib"],
    github: "https://github.com/sophieyzhou/grid-load-balancing",
    hasGithub: true,
    detailsPage: "/projects/energy-optimizer",
  },
  {
    title: "Astronomical Orbital Model",
    description: "Models the behavior of astronomical objects in a multi-item system to account for gravitational force interaction using ordinary differential equations.",
    techStack: ["scipy", "matplotlib", "Python"],
    github: "https://github.com/sophieyzhou/astronomical-odes",
    hasGithub: true,
    detailsPage: "/projects/astronomical-odes",
  },
  {
    title: "Project Team Website",
    description: "Designed and developed multi page website for biomedical engineering project team",
    techStack: ["JavaScript", "Typescript", "React", "CSS"],
    github: "https://github.com/sophieyzhou/teamflow.github.io",
    hasGithub: true,
    detailsPage: "/projects/flow-website",
  },
  {
    title: "Lavender Farm Financials",
    description: "Built cost allocation models for Michigan’s largest lavender farm.",
    techStack: ["Excel", "Tableau", "Python"],
    github: "",
    hasGithub: false,
    detailsPage: "/projects/lavender-farm",
  },
];